module.exports = __webpack_public_path__ + "img/bg-maininfo.04a95985.png";